import { Outlet } from "react-router-dom";
import { Layout } from "antd";

import Navbar from "../components/common/header/Navbar";
import Sidebar from "../components/common/sidebar/Sidebar";
import { useState } from "react";
import { useCurrentUser } from "../api/hooks/auth";
import LogoLoader from "../components/common/LogoLoader";
import ErrorBoundary from "../components/common/ErrorBoundary";
const { Header, Sider, Content } = Layout;

function BaseLayout() {
  const [collapsed, setCollapsed] = useState(false);

  const { data: user, isLoading, isError, error } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex h-full flex-col items-center justify-center">
        <LogoLoader />
        <span className="text-xl font-bold text-[#667DBE]">MyWorkApp.io</span>
      </div>
    );
  }

  if (isError) {
    console.error("----->", error);
    return <ErrorBoundary />;
  }

  return (
    <Layout className="h-full" style={{ minHeight: "100vh" }}>
      <Header className="sticky top-0 flex border-b px-0">
        <Navbar />
      </Header>
      <Layout hasSider className="overflow-auto">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content className="watermark-container">
          <div className="watermark" />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default BaseLayout;
